























































































































import { isDisplayItem } from '@/models/cart/group/group'
import { formatPrice } from '@/util/format'
import { CheckoutStore } from '@spa/components/pages/order/order/models/checkout-store'
import {
  filterValidItemAsAggregate,
  isSinglePurchasable,
} from '@spa/store/modules/cart/function'
import { CartItem } from '@spa/store/modules/cart/types'
import _ from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class PriceSummaryForCheckoutStore extends Vue {
  @Prop({ required: true })
  readonly checkoutStore: CheckoutStore

  // カタログ応募の場合にestimateは送料0円で返してくれないらしいので
  @Prop({ default: false })
  readonly isFreeShipping: boolean

  @Prop({ required: true })
  readonly serviceFeePercent: number

  @Prop({ required: true })
  readonly pointIsEnabled: boolean

  @Prop({ required: true })
  readonly isLoading: boolean

  get totalItemCount(): number {
    return this.checkoutStore.itemCount
  }

  get noveltyCount(): number {
    return this.checkoutStore.noveltyCount
  }

  get totalPrice(): string {
    return formatPrice(this.checkoutStore.totalPrice)
  }

  get subtotalPrice(): string {
    return formatPrice(this.checkoutStore.subtotalPrice)
  }

  get shippingList(): number[] {
    return this.checkoutStore.shippingList
  }

  get totalShipping(): string {
    return formatPrice(this.isFreeShipping ? 0 : this.checkoutStore.shipping)
  }

  get commissionList(): number[] {
    return this.checkoutStore.commissionList
  }

  get totalCommission(): string {
    return formatPrice(this.checkoutStore.commission)
  }

  get hasCommission(): boolean {
    return this.commissionList.length > 0
  }

  get serviceFees(): number[] {
    return this.checkoutStore.serviceFeeList
  }

  get totalServiceFee(): string {
    return formatPrice(this.checkoutStore.serviceFee)
  }

  get hasServiceFee(): boolean {
    return this.serviceFees.length > 0
  }

  get totalBundleDiscountAmount(): number {
    return this.checkoutStore.bundleDiscountPrice
  }

  get totalBundleDiscount(): string {
    return formatPrice(this.totalBundleDiscountAmount)
  }

  get hasBundleDiscount(): boolean {
    return this.totalBundleDiscountAmount > 0
  }

  get totalCouponDiscountAmount(): number {
    return this.checkoutStore.couponDiscountPrice
  }

  get totalCouponDiscount(): string {
    return formatPrice(this.totalCouponDiscountAmount)
  }

  get hasCouponDiscount(): boolean {
    return this.totalCouponDiscountAmount > 0
  }

  get totalPointDiscountAmount(): number {
    return this.checkoutStore.pointDiscountPrice
  }

  get totalPointDiscount(): string {
    return formatPrice(this.totalPointDiscountAmount)
  }

  get hasPointDiscount(): boolean {
    return this.totalPointDiscountAmount > 0
  }

  get estimatedPoint(): number {
    return this.checkoutStore.estimatedPoint
  }

  /**
   * TODO: 実装の重複解除
   * 既存でOrder.vueがstoreとisSinglePurchasableを利用してフィルタリングしたもの
   */
  filterDisplayItems(items: CartItem[]): CartItem[] {
    return items
      .filter(item => filterValidItemAsAggregate(item, items))
      .filter(item => isDisplayItem(item))
      .filter(item => isSinglePurchasable(item))
  }
}
